import { EnumTipoDomandaModuloDTOTipoAssociazione } from '@framework/api-client/api/inquiries/schemas/enumTipoDomandaModuloDTOTipoAssociazione.ts';
import { type ISubmissionModules } from '@framework/frontoffice-submission/submission/hooks/useSubmissionModules.ts';
import { LoaderSpin } from '@framework/ui/components/loader/LoaderSpin.tsx';
import {
  generatePath,
  useHistory,
} from '@framework/ui/core/router/TypedRoute.tsx';

export interface ISubmissionPrincipalModuleRedirectorProps {
  submissionId: string | null | undefined;
  submissionModules: ISubmissionModules;
}

export function SubmissionPrincipalModuleRedirector(
  props: ISubmissionPrincipalModuleRedirectorProps,
) {
  const { submissionModules, submissionId } = props;

  const history = useHistory();

  // Fase di caricamento
  if (submissionModules.isLoading) {
    return <LoaderSpin full />;
  }

  // Ricavo il modulo principale
  const principalModule = submissionModules.modules.find(
    m =>
      m.domandaModulo?.tipoAssociazione ===
      EnumTipoDomandaModuloDTOTipoAssociazione.PRINCIPALE,
  );

  if (principalModule) {
    history.push(
      generatePath('/richieste/:id/moduli/:moduleId', {
        id: submissionId!,
        moduleId: principalModule.id!,
      }),
    );
    return;
  }

  // Come fallback, redirect alla pagina di guida alla compilazione
  history.push(generatePath('/richieste/:id', { id: submissionId! }));

  return null;
}
